import type _Vue from 'vue'
import DashAggConfig from '@/configurations/aggregator/dash.json'
import HagertyAggConfig from '@/configurations/aggregator/hagerty.json'
import IgniteAggConfig from '@/configurations/aggregator/ignite.json'
import KeeyPartnersAggConfig from '@/configurations/aggregator/keeypartners.json'
import QuotaxAggConfig from '@/configurations/aggregator/quotax.json'
import SwitchAggConfig from '@/configurations/aggregator/switch.json'
import TractiveAggConfig from '@/configurations/aggregator/tractive.json'
import YogaAggConfig from '@/configurations/aggregator/yoga.json'
import ZenAggConfig from '@/configurations/aggregator/zen.json'
import ZoomcoverAggConfig from '@/configurations/aggregator/zoomcover.json'
import ConfigurationLoader from '@/configurations/ConfigurationLoader'
import DashExperimentsConfig from '@/configurations/experiments/dash.json'
import HagertyExperimentsConfig from '@/configurations/experiments/hagerty.json'
import IgniteExperimentsConfig from '@/configurations/experiments/ignite.json'
import KeeyPartnersExperimentsConfig from '@/configurations/experiments/keeypartners.json'
import QuotaxExperimentsConfig from '@/configurations/experiments/quotax.json'
import SwitchExperimentsConfig from '@/configurations/experiments/switch.json'
import TractiveExperimentsConfig from '@/configurations/experiments/tractive.json'
import YogaExperimentsConfig from '@/configurations/experiments/yoga.json'
import ZenExperimentsConfig from '@/configurations/experiments/zen.json'
import ZoomcoverExperimentsConfig from '@/configurations/experiments/zoomcover.json'
import DashGeneralConfig from '@/configurations/general/dash.json'
import demo02GeneralConfig from '@/configurations/general/demo02.json'
import HagertyGeneralConfig from '@/configurations/general/hagerty.json'
import IgniteGeneralConfig from '@/configurations/general/ignite.json'
import KeeyPartnersGeneralConfig from '@/configurations/general/keeypartners.json'
import QuotaxGeneralConfig from '@/configurations/general/quotax.json'
import SwitchGeneralConfig from '@/configurations/general/switch.json'
import TractiveGeneralConfig from '@/configurations/general/tractive.json'
import YogaGeneralConfig from '@/configurations/general/yoga.json'
import ZenGeneralConfig from '@/configurations/general/zen.json'
import ZoomcoverGeneralConfig from '@/configurations/general/zoomcover.json'
import DashJourneyConfig from '@/configurations/journey/dash.json'
import HagertyJourneyConfig from '@/configurations/journey/hagerty.json'
import IgniteJourneyConfig from '@/configurations/journey/ignite.json'
import KeeyPartnersJourneyConfig from '@/configurations/journey/keeypartners.json'
import QuotaxJourneyConfig from '@/configurations/journey/quotax.json'
import SwitchJourneyConfig from '@/configurations/journey/switch.json'
import TractiveJourneyConfig from '@/configurations/journey/tractive.json'
import YogaJourneyConfig from '@/configurations/journey/yoga.json'
import ZenJourneyConfig from '@/configurations/journey/zen.json'
import ZoomcoverJourneyConfig from '@/configurations/journey/zoomcover.json'
import TenantEnum from '@/services/enums/TenantEnum'

export interface IConfigurationOptions {
  tenant: TenantEnum
}

export default function ConfigurationPlugin(Vue: typeof _Vue, options: IConfigurationOptions): void {
  switch (options.tenant) {
    case TenantEnum.Dash:
      // @ts-expect-error JSON object types are so wrong...
      Vue.prototype.$configurations = ConfigurationLoader.createConfiguration(DashGeneralConfig, DashAggConfig, DashJourneyConfig, DashExperimentsConfig)
      break
    case TenantEnum.Hagerty:
      // @ts-expect-error JSON object types are so wrong...
      Vue.prototype.$configurations = ConfigurationLoader.createConfiguration(HagertyGeneralConfig, HagertyAggConfig, HagertyJourneyConfig, HagertyExperimentsConfig)
      break
    case TenantEnum.Ignite:
      // @ts-expect-error JSON object types are so wrong...
      Vue.prototype.$configurations = ConfigurationLoader.createConfiguration(IgniteGeneralConfig, IgniteAggConfig, IgniteJourneyConfig, IgniteExperimentsConfig)
      break
    case TenantEnum.KeeyPartners:
      // @ts-expect-error JSON object types are so wrong...
      Vue.prototype.$configurations = ConfigurationLoader.createConfiguration(KeeyPartnersGeneralConfig, KeeyPartnersAggConfig, KeeyPartnersJourneyConfig, KeeyPartnersExperimentsConfig)
      break
    case TenantEnum.Quotax:
      // @ts-expect-error JSON object types are so wrong...
      Vue.prototype.$configurations = ConfigurationLoader.createConfiguration(QuotaxGeneralConfig, QuotaxAggConfig, QuotaxJourneyConfig, QuotaxExperimentsConfig)
      break
    case TenantEnum.Switch:
      // @ts-expect-error JSON object types are so wrong...
      Vue.prototype.$configurations = ConfigurationLoader.createConfiguration(SwitchGeneralConfig, SwitchAggConfig, SwitchJourneyConfig, SwitchExperimentsConfig)
      break
    case TenantEnum.Tractive:
      // @ts-expect-error JSON object types are so wrong...
      Vue.prototype.$configurations = ConfigurationLoader.createConfiguration(TractiveGeneralConfig, TractiveAggConfig, TractiveJourneyConfig, TractiveExperimentsConfig)
      break
    case TenantEnum.Yoga:
      // @ts-expect-error JSON object types are so wrong...
      Vue.prototype.$configurations = ConfigurationLoader.createConfiguration(YogaGeneralConfig, YogaAggConfig, YogaJourneyConfig, YogaExperimentsConfig)
      break
    case TenantEnum.Demo02:
      // @ts-expect-error JSON object types are so wrong...
      Vue.prototype.$configurations = ConfigurationLoader.createConfiguration(demo02GeneralConfig, YogaAggConfig, YogaJourneyConfig, YogaExperimentsConfig)
      break
    case TenantEnum.Zen:
      // @ts-expect-error JSON object types are so wrong...
      Vue.prototype.$configurations = ConfigurationLoader.createConfiguration(ZenGeneralConfig, ZenAggConfig, ZenJourneyConfig, ZenExperimentsConfig)
      break
    case TenantEnum.Zoomcover:
      // @ts-expect-error JSON object types are so wrong...
      Vue.prototype.$configurations = ConfigurationLoader.createConfiguration(ZoomcoverGeneralConfig, ZoomcoverAggConfig, ZoomcoverJourneyConfig, ZoomcoverExperimentsConfig)
      break
    default:
      throw new Error(`Unable to find tenant configuration for: ${options.tenant}.`)
  }
}
